<template>
  <div>
    <table v-if="isStatTableVisible" class="prop-table">
      <tr>
        <th>Количество игроков</th>
        <td class="text-right">{{rush.playerAmount | getFormattedNumber}}</td>
      </tr>
      <tr>
        <th>Количество заездов</th>
        <td class="text-right">{{rush.raceAmount | getFormattedNumber}}</td>
      </tr>
      <tr>
        <th>Количество открытых заездов</th>
        <td class="text-right">{{rush.openRaceAmount | getFormattedNumber}}</td>
      </tr>
    </table>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator from './LoadingIndicator.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'RushStat',

  components: {
    LoadingIndicator,
  },

  props: {
    rushId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,
      rush: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {boolean} */
    isStatTableVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      return this.rush !== null;
    },
  },

  created() {
    this.loadStat();
  },

  methods: {
    loadStat() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = `/rush/${this.rushId}/stat`;

      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          this.loadingStatus = LOADING_STATUS__ERROR;
          return;
        }

        this.rush = data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>
